// import Swiper JS
import Swiper, { Navigation } from "swiper";
import NavBar from "../components/navbar";
// import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

new NavBar();

function initTVSlider() {
  const wrapper = document.querySelector(".brand-tv-slider");
  const slider = wrapper.querySelector(".swiper");
  const next = wrapper.querySelector(".tv-slider-next");

  new Swiper(slider, {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 10,
    threshold: 15,
    loopFillGroupWithBlank: true,
    loop: true,
    navigation: {
      nextEl: next,
    },
    breakpoints: {
      450: {
        slidesPerView: 2,
      },
      550: {
        slidesPerView: 3,
      },
      767: {
        slidesPerView: 2,
      },
      900: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
      1224: {
        slidesPerView: 5,
      },
    },
  });
}

function initBrandSlider() {
  const wrapper = document.querySelector(".brand-outro");

  if (wrapper) {
    const slider = wrapper.querySelector(".swiper");

    const next = wrapper.querySelector(".brand-slider-next");
    const prev = wrapper.querySelector(".brand-slider-prev");

    new Swiper(slider, {
      modules: [Navigation],
      slidesPerView: 1,
      threshold: 15,
      loop: true,
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
    });
  }
}

addEventListener("DOMContentLoaded", function () {
  initTVSlider();
  initBrandSlider();
});
